var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvatar = function SvgAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#avatar_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.299 11H15.7C12.558 11 10 13.52 10 16.62c0 3.098 2.558 5.618 5.701 5.618h2.157v-2.862H15.7c-1.542 0-2.796-1.237-2.796-2.756 0-1.52 1.254-2.757 2.796-2.757H20.3c1.542 0 2.797 1.237 2.797 2.757v.047c0 .823-.37 1.597-1.012 2.122l-4.28 3.498h.008V26l6.126-5.007A5.573 5.573 0 0 0 26 16.667v-.047c0-3.1-2.558-5.62-5.701-5.62"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "avatar_svg__a",
    x1: 18,
    x2: 18,
    y1: 0,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#061522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#405261"
  })))));
};
export { SvgAvatar as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZjUxOTI2YmMzMmVmMzQ0ZjdlZWY4YTAyNDYwZWZiNGUuc3ZnIjs=";